import {
  faBadgePercent,
  faBullseyeArrow, faCalendarCheck,
  faCalendarDays, faCalendarXmark,
  faCrosshairs, faTally, faWarning,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Form, Grid } from '@domain-group/suit-theme'

import ListItemWithIcon from './ListItemWithIcon'

const TableKeys = () => (
  <>
    <Form.Field
      label="Index"
      labelProps={{
        marginBottom: 'medium',
        marginLeft: '20px',
        marginTop: 'large',
      }}
    />

    <Grid gridAutoRows="1fr" gridTemplateColumns="repeat(4, minmax(25%, 1fr))" marginBottom="large">
      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faTally} />}
        label="Total Task Count"
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faCalendarCheck} />}
        label="No. of Tasks Within SLA "
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faCalendarXmark} />}
        label="No. of Tasks Outside SLA "
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faCalendarDays} />}
        label="SLA Percent "
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faBullseyeArrow} />}
        label="No. of First Time Right "
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faWarning} />}
        label="No. of Jobs with QC Errors"
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faBadgePercent} />}
        label="First Time Right Percent"
      />

      <ListItemWithIcon
        icon={<FontAwesomeIcon icon={faCrosshairs} />}
        label="QC Accuracy Rating"
      />
    </Grid>
  </>
)

export default TableKeys
